(function (window, $) {

    var wizard;
    var respondBy;
    var eventType = "Meeting";

    var rfpURL = "https://mbrfp.meetingbroker.com/OmniHotels/RFPMeeting/API/ClientRequestForProposal";

    var countryJSON = [
        {"id": "US","display": "UNITED STATES"},
        {"id": "AF","display": "AFGHANISTAN"},
        {"id": "AX","display": "ÅLAND ISLANDS"},
        {"id": "AL","display": "ALBANIA"},
        {"id": "DZ","display": "ALGERIA"},
        {"id": "AS","display": "AMERICAN SAMOA"},
        {"id": "AD","display": "ANDORRA"},
        {"id": "AO","display": "ANGOLA"},
        {"id": "AI","display": "ANGUILLA"},
        {"id": "AQ","display": "ANTARCTICA"},
        {"id": "AG","display": "ANTIGUA AND BARBUDA"},
        {"id": "AR","display": "ARGENTINA"},
        {"id": "AM","display": "ARMENIA"},
        {"id": "AW","display": "ARUBA"},
        {"id": "AU","display": "AUSTRALIA"},
        {"id": "AT","display": "AUSTRIA"},
        {"id": "AZ","display": "AZERBAIJAN"},
        {"id": "BS","display": "BAHAMAS"},
        {"id": "BH","display": "BAHRAIN"},
        {"id": "BD","display": "BANGLADESH"},
        {"id": "BB","display": "BARBADOS"},
        {"id": "BY","display": "BELARUS"},
        {"id": "BE","display": "BELGIUM"},
        {"id": "BZ","display": "BELIZE"},
        {"id": "BJ","display": "BENIN"},
        {"id": "BM","display": "BERMUDA"},
        {"id": "BT","display": "BHUTAN"},
        {"id": "BO","display": "BOLIVIA"},
        {"id": "BQ","display": "BONAIRE, SINT EUSTATIUS AND SABA"},
        {"id": "BA","display": "BOSNIA AND HERZEGOVINA"},
        {"id": "BW","display": "BOTSWANA"},
        {"id": "BV","display": "BOUVET ISLAND"},
        {"id": "BR","display": "BRAZIL"},
        {"id": "IO","display": "BRITISH INDIAN OCEAN TERRITORY"},
        {"id": "BN","display": "BRUNEI DARUSSALAM"},
        {"id": "BG","display": "BULGARIA"},
        {"id": "BF","display": "BURKINA FASO"},
        {"id": "BI","display": "BURUNDI"},
        {"id": "KH","display": "CAMBODIA"},
        {"id": "CM","display": "CAMEROON"},
        {"id": "CA","display": "CANADA"},
        {"id": "CV","display": "CAPE VERDE"},
        {"id": "KY","display": "CAYMAN ISLANDS"},
        {"id": "CF","display": "CENTRAL AFRICAN REPUBLIC"},
        {"id": "TD","display": "CHAD"},
        {"id": "CL","display": "CHILE"},
        {"id": "CN","display": "CHINA"},
        {"id": "CX","display": "CHRISTMAS ISLAND"},
        {"id": "CC","display": "COCOS (KEELING) ISLANDS"},
        {"id": "CO","display": "COLOMBIA"},
        {"id": "KM","display": "COMOROS"},
        {"id": "CG","display": "CONGO"},
        {"id": "CD","display": "CONGO, THE DEMOCRATIC REPUBLIC OF THE"},
        {"id": "CK","display": "COOK ISLANDS"},
        {"id": "CR","display": "COSTA RICA"},
        {"id": "HR","display": "CROATIA"},
        {"id": "CI","display": "CTE D'IVOIRE"},
        {"id": "CU","display": "CUBA"},
        {"id": "CW","display": "CURAÇAO"},
        {"id": "CY","display": "CYPRUS"},
        {"id": "CZ","display": "CZECH REPUBLIC"},
        {"id": "DK","display": "DENMARK"},
        {"id": "DJ","display": "DJIBOUTI"},
        {"id": "DM","display": "DOMINICA"},
        {"id": "DO","display": "DOMINICAN REPUBLIC"},
        {"id": "EC","display": "ECUADOR"},
        {"id": "EG","display": "EGYPT"},
        {"id": "SV","display": "EL SALVADOR"},
        {"id": "GQ","display": "EQUATORIAL GUINEA"},
        {"id": "ER","display": "ERITREA"},
        {"id": "EE","display": "ESTONIA"},
        {"id": "ET","display": "ETHIOPIA"},
        {"id": "FK","display": "FALKLAND ISLANDS (MALVINAS)"},
        {"id": "FO","display": "FAROE ISLANDS"},
        {"id": "FJ","display": "FIJI"},
        {"id": "FI","display": "FINLAND"},
        {"id": "FR","display": "FRANCE"},
        {"id": "GF","display": "FRENCH GUIANA"},
        {"id": "PF","display": "FRENCH POLYNESIA"},
        {"id": "TF","display": "FRENCH SOUTHERN TERRITORIES"},
        {"id": "GA","display": "GABON"},
        {"id": "GM","display": "GAMBIA"},
        {"id": "GE","display": "GEORGIA"},
        {"id": "DE","display": "GERMANY"},
        {"id": "GH","display": "GHANA"},
        {"id": "GI","display": "GIBRALTAR"},
        {"id": "GR","display": "GREECE"},
        {"id": "GL","display": "GREENLAND"},
        {"id": "GD","display": "GRENADA"},
        {"id": "GP","display": "GUADELOUPE"},
        {"id": "GU","display": "GUAM"},
        {"id": "GT","display": "GUATEMALA"},
        {"id": "GG","display": "GUERNSEY"},
        {"id": "GN","display": "GUINEA"},
        {"id": "GW","display": "GUINEA-BISSAU"},
        {"id": "GY","display": "GUYANA"},
        {"id": "HT","display": "HAITI"},
        {"id": "HM","display": "HEARD ISLAND AND MCDONALD ISLANDS"},
        {"id": "VA","display": "HOLY SEE (VATICAN CITY STATE)"},
        {"id": "HN","display": "HONDURAS"},
        {"id": "HK","display": "HONG KONG"},
        {"id": "HU","display": "HUNGARY"},
        {"id": "IS","display": "ICELAND"},
        {"id": "IN","display": "INDIA"},
        {"id": "ID","display": "INDONESIA"},
        {"id": "IR","display": "IRAN, ISLAMIC REPUBLIC OF"},
        {"id": "IQ","display": "IRAQ"},
        {"id": "IE","display": "IRELAND"},
        {"id": "IM","display": "ISLE OF MAN"},
        {"id": "IL","display": "ISRAEL"},
        {"id": "IT","display": "ITALY"},
        {"id": "JM","display": "JAMAICA"},
        {"id": "JP","display": "JAPAN"},
        {"id": "JE","display": "JERSEY"},
        {"id": "JO","display": "JORDAN"},
        {"id": "KZ","display": "KAZAKHSTAN"},
        {"id": "KE","display": "KENYA"},
        {"id": "KI","display": "KIRIBATI"},
        {"id": "KP","display": "KOREA, DEMOCRATIC PEOPLE'S REPUBLIC OF"},
        {"id": "KR","display": "KOREA, REPUBLIC OF"},
        {"id": "KW","display": "KUWAIT"},
        {"id": "KG","display": "KYRGYZSTAN"},
        {"id": "LA","display": "LAO PEOPLE'S DEMOCRATIC REPUBLIC"},
        {"id": "LV","display": "LATVIA"},
        {"id": "LB","display": "LEBANON"},
        {"id": "LS","display": "LESOTHO"},
        {"id": "LR","display": "LIBERIA"},
        {"id": "LY","display": "LIBYAN ARAB JAMAHIRIYA"},
        {"id": "LI","display": "LIECHTENSTEIN"},
        {"id": "LT","display": "LITHUANIA"},
        {"id": "LU","display": "LUXEMBOURG"},
        {"id": "MO","display": "MACAO"},
        {"id": "MK","display": "MACEDONIA, THE FORMER YUGOSLAV REPUBLIC OF"},
        {"id": "MG","display": "MADAGASCAR"},
        {"id": "MW","display": "MALAWI"},
        {"id": "MY","display": "MALAYSIA"},
        {"id": "MV","display": "MALDIVES"},
        {"id": "ML","display": "MALI"},
        {"id": "MT","display": "MALTA"},
        {"id": "MH","display": "MARSHALL ISLANDS"},
        {"id": "MQ","display": "MARTINIQUE"},
        {"id": "MR","display": "MAURITANIA"},
        {"id": "MU","display": "MAURITIUS"},
        {"id": "YT","display": "MAYOTTE"},
        {"id": "MX","display": "MEXICO"},
        {"id": "FM","display": "MICRONESIA, FEDERATED STATES OF"},
        {"id": "MD","display": "MOLDOVA, REPUBLIC OF"},
        {"id": "MC","display": "MONACO"},
        {"id": "MN","display": "MONGOLIA"},
        {"id": "ME","display": "MONTENEGRO"},
        {"id": "MS","display": "MONTSERRAT"},
        {"id": "MA","display": "MOROCCO"},
        {"id": "MZ","display": "MOZAMBIQUE"},
        {"id": "MM","display": "MYANMAR"},
        {"id": "NA","display": "NAMIBIA"},
        {"id": "NR","display": "NAURU"},
        {"id": "NP","display": "NEPAL"},
        {"id": "NL","display": "NETHERLANDS"},
        {"id": "AN","display": "NETHERLANDS ANTILLES"},
        {"id": "NC","display": "NEW CALEDONIA"},
        {"id": "NZ","display": "NEW ZEALAND"},
        {"id": "NI","display": "NICARAGUA"},
        {"id": "NE","display": "NIGER"},
        {"id": "NG","display": "NIGERIA"},
        {"id": "NU","display": "NIUE"},
        {"id": "NF","display": "NORFOLK ISLAND"},
        {"id": "MP","display": "NORTHERN MARIANA ISLANDS"},
        {"id": "NO","display": "NORWAY"},
        {"id": "OM","display": "OMAN"},
        {"id": "PK","display": "PAKISTAN"},
        {"id": "PW","display": "PALAU"},
        {"id": "PS","display": "PALESTINIAN TERRITORY, OCCUPIED"},
        {"id": "PA","display": "PANAMA"},
        {"id": "PG","display": "PAPUA NEW GUINEA"},
        {"id": "PY","display": "PARAGUAY"},
        {"id": "PE","display": "PERU"},
        {"id": "PH","display": "PHILIPPINES"},
        {"id": "PN","display": "PITCAIRN"},
        {"id": "PL","display": "POLAND"},
        {"id": "PT","display": "PORTUGAL"},
        {"id": "PR","display": "PUERTO RICO"},
        {"id": "QA","display": "QATAR"},
        {"id": "RO","display": "ROMANIA"},
        {"id": "RE","display": "RUNION"},
        {"id": "RU","display": "RUSSIAN FEDERATION"},
        {"id": "RW","display": "RWANDA"},
        {"id": "BL","display": "SAINT BARTHÉLEMY"},
        {"id": "SH","display": "SAINT HELENA"},
        {"id": "KN","display": "SAINT KITTS AND NEVIS"},
        {"id": "LC","display": "SAINT LUCIA"},
        {"id": "MF","display": "SAINT MARTIN (FRENCH PART)"},
        {"id": "PM","display": "SAINT PIERRE AND MIQUELON"},
        {"id": "VC","display": "SAINT VINCENT AND THE GRENADINES"},
        {"id": "WS","display": "SAMOA"},
        {"id": "SM","display": "SAN MARINO"},
        {"id": "ST","display": "SAO TOME AND PRINCIPE"},
        {"id": "SA","display": "SAUDI ARABIA"},
        {"id": "SN","display": "SENEGAL"},
        {"id": "RS","display": "SERBIA"},
        {"id": "SC","display": "SEYCHELLES"},
        {"id": "SL","display": "SIERRA LEONE"},
        {"id": "SG","display": "SINGAPORE"},
        {"id": "SX","display": "SINT MAARTEN (DUTCH PART)"},
        {"id": "SK","display": "SLOVAKIA"},
        {"id": "SI","display": "SLOVENIA"},
        {"id": "SB","display": "SOLOMON ISLANDS"},
        {"id": "SO","display": "SOMALIA"},
        {"id": "ZA","display": "SOUTH AFRICA"},
        {"id": "GS","display": "SOUTH GEORGIA AND THE SOUTH SANDWICH ISLANDS"},
        {"id": "SS","display": "SOUTH SUDAN"},
        {"id": "ES","display": "SPAIN"},
        {"id": "LK","display": "SRI LANKA"},
        {"id": "SD","display": "SUDAN"},
        {"id": "SR","display": "SURINAME"},
        {"id": "SJ","display": "SVALBARD AND JAN MAYEN"},
        {"id": "SZ","display": "SWAZILAND"},
        {"id": "SE","display": "SWEDEN"},
        {"id": "CH","display": "SWITZERLAND"},
        {"id": "SY","display": "SYRIAN ARAB REPUBLIC"},
        {"id": "TW","display": "TAIWAN, PROVINCE OF CHINA"},
        {"id": "TJ","display": "TAJIKISTAN"},
        {"id": "TZ","display": "TANZANIA, UNITED REPUBLIC OF"},
        {"id": "TH","display": "THAILAND"},
        {"id": "TL","display": "TIMOR-LESTE"},
        {"id": "TG","display": "TOGO"},
        {"id": "TK","display": "TOKELAU"},
        {"id": "TO","display": "TONGA"},
        {"id": "TT","display": "TRINIDAD AND TOBAGO"},
        {"id": "TN","display": "TUNISIA"},
        {"id": "TR","display": "TURKEY"},
        {"id": "TM","display": "TURKMENISTAN"},
        {"id": "TC","display": "TURKS AND CAICOS ISLANDS"},
        {"id": "TV","display": "TUVALU"},
        {"id": "UG","display": "UGANDA"},
        {"id": "UA","display": "UKRAINE"},
        {"id": "AE","display": "UNITED ARAB EMIRATES"},
        {"id": "GB","display": "UNITED KINGDOM"},
        {"id": "UM","display": "UNITED STATES MINOR OUTLYING ISLANDS"},
        {"id": "UY","display": "URUGUAY"},
        {"id": "UZ","display": "UZBEKISTAN"},
        {"id": "VU","display": "VANUATU"},
        {"id": "VE","display": "VENEZUELA"},
        {"id": "VN","display": "VIET NAM"},
        {"id": "VG","display": "VIRGIN ISLANDS, BRITISH"},
        {"id": "VI","display": "VIRGIN ISLANDS, U.S."},
        {"id": "WF","display": "WALLIS AND FUTUNA"},
        {"id": "EH","display": "WESTERN SAHARA"},
        {"id": "YE","display": "YEMEN"},
        {"id": "YU","display": "YUGOSLAVIA"},
        {"id": "ZM","display": "ZAMBIA"},
        {"id": "ZW","display": "ZIMBABWE"}
    ];


    function onDocReady() {
        if($(".rfp-wizard-section").length) {
            wizard = $(".rfp-wizard-section");

            // setup the date range input
            // info at http://www.daterangepicker.com/
            $("#rfp-date-range").daterangepicker({
                autoUpdateInput: false,
                autoApply: true,
                locale: {
                    cancelLabel: 'Clear'
                }
            });

            $('input[name="wedding-date"]').daterangepicker({
                autoUpdateInput: false,
                autoApply: true,
                locale: {
                    cancelLabel: 'Clear'
                },
                singleDatePicker: true,
                showDropdowns: true
            });

            $("#rfp-date-range").on('apply.daterangepicker', function (ev, picker) {

                console.log("picked date");

                $(this).val(picker.startDate.format('MM/DD/YYYY') + ' - ' + picker.endDate.format('MM/DD/YYYY'));

                $("#rfp-start-date").val(picker.startDate.format('YYYY-MM-DD'));
                $("#rfp-end-date").val(picker.endDate.format('YYYY-MM-DD'));

                // handle the guest room inputs
                calculateDates(picker.startDate.format('YYYY-MM-DD'), picker.endDate.format('YYYY-MM-DD'));


                if (!$(this)[0].checkValidity()) {
                    shouldSubmit = false;
                    $(this).addClass("input-error");
                }
                else {
                    $(this).removeClass("input-error");
                    console.log("valid");
                    if($("[name='need-guest-rooms']:checked").val() === "Yes") {
                        console.log("need rooms");
                        $(".guest-rooms-form").find(".form-row .input-container").removeClass("hidden");
                        $(".guest-rooms-form").find(".form-row .input-container input").attr("disabled",false);
                        $(".guest-rooms-form .form-row").find(".error-text").remove();
                    }
                }

            });

            $('input[name="wedding-date"]').on('apply.daterangepicker', function (ev, picker) {
                $(this).val(picker.startDate.format('MM-DD-YYYY'));

                respondBy = new Date(Date.parse(picker.startDate.format('MM-DD-YYYY')) + (7 * 24 * 60 * 60 * 1000));

                if(!$(this)[0].checkValidity()) {
                    shouldSubmit = false;
                    $(this).addClass("input-error");
                }
                else {
                    $(this).removeClass("input-error");
                }
            });

            $("#rfp-date-range").on('cancel.daterangepicker', function (ev, picker) {
                $(this).val('');

                if(!$(this)[0].checkValidity()) {
                    shouldSubmit = false;
                    $(this).addClass("input-error");
                }
                else {
                    $(this).removeClass("input-error");
                }
            });

            // register the submit button
            $(".submit-rfp-button").click(submitRFP);

            // register the radio toggles for the rfp type (Meeting, Wedding, Social)
            $("[name='meeting-type']").click(typeChange);

            $("[name='need-guest-rooms']").click(changeNeedGuestRooms);

            $(".rfp-wizard input").change(inputChange);
            $(".rfp-wizard select").change(inputChange);

            // register the delete buttons on the hotel items
            wizard.find(".hotel .delete-icon").click(deleteHotel);

            // populate country select
            var countryHTML = '';
            for (var country = 0; country < countryJSON.length; country++) {
                countryHTML += '<option value="' + countryJSON[country].id + '">' + countryJSON[country].display + '</option>';
            }
            $("#rfp-country").append(countryHTML);

            $('[name="meeting-type"]').each(function () {
                if ($(this).is(':checked')) {
                    $(this).click();
                }
            });

        }
    }

    function changeNeedGuestRooms() {

        var guestRoomsForm = $(".guest-rooms-form");

        // if no date specified
        if($("#rfp-date-range").val() === "") {
            // if need rooms
            if($("[name='need-guest-rooms']:checked").val() === "Yes") {
                // if error doesn't already exist
                if(!$(".guest-rooms-form .form-row .error-text").length) {
                    $(".guest-rooms-form .form-row").append('<span class="error-text">Please select Meeting Dates.</span>')
                }
            }
            else {
                $(".guest-rooms-form .form-row").find(".error-text").remove();
                guestRoomsForm.find(".form-row .input-container").addClass("hidden");
                guestRoomsForm.find(".form-row .input-container input").attr("disabled", true);
            }
        }
        else {
            if($("[name='need-guest-rooms']:checked").val() === "Yes") {
                guestRoomsForm.find(".form-row .input-container").removeClass("hidden");
                guestRoomsForm.find(".form-row .input-container input").attr("disabled",false);
                $(".guest-rooms-form .form-row").find(".error-text").remove();
            }
            else {
                $(".guest-rooms-form .form-row").find(".error-text").remove();
                guestRoomsForm.find(".form-row .input-container").addClass("hidden");
                guestRoomsForm.find(".form-row .input-container input").attr("disabled", true);
            }
        }
    }

    function typeChange() {
        if($(this).val() === "Meeting") {
            // remove disabled from meeting inputs
            $(".input-container").find("input").prop("disabled", false);
            $(".input-container").find("select").prop("disabled", false);
            $(".input-container").removeClass("hidden");

            $(".input-container").each(function() {
               if(!$(this).hasClass("meeting-input")) {
                   $(this).addClass("hidden");
                   $(this).find("input").prop("disabled", true);
                   $(this).find("select").prop("disabled", true);
               }
            });

            eventType = "Meeting";

            if($("[name='need-guest-rooms']:checked").val() === "Yes") {
                $(".date-cell input").attr("disabled",false);
            }

            $(".guest-rooms-form .form-row .error-text").removeClass("hidden");
        }
        else {
            if($(this).val() === "Wedding") {
                // remove disabled from meeting inputs
                $(".input-container").find("input").prop("disabled", false);
                $(".input-container").find("select").prop("disabled", false);
                $(".input-container").removeClass("hidden");

                $(".input-container").each(function() {
                    if(!$(this).hasClass("wedding-input")) {
                        $(this).addClass("hidden");
                        $(this).find("input").prop("disabled", true);
                        $(this).find("select").prop("disabled", true);
                    }
                });

                eventType = "Wedding";

                $(".date-cell input").attr("disabled",true);
                $(".guest-rooms-form .form-row .error-text").addClass("hidden");
            }
            else {
                if($(this).val() === "Social") {
                    // remove disabled from meeting inputs
                    $(".input-container").find("input").prop("disabled", false);
                    $(".input-container").find("select").prop("disabled", false);
                    $(".input-container").removeClass("hidden");

                    $(".input-container").each(function() {
                        if(!$(this).hasClass("social-input")) {
                            $(this).addClass("hidden");
                            $(this).find("input").prop("disabled", true);
                            $(this).find("select").prop("disabled", true);
                        }
                    });

                    eventType = "Social";

                    if($("[name='need-guest-rooms']:checked").val() === "Yes") {
                        $(".date-cell input").attr("disabled",false);
                    }
                    $(".guest-rooms-form .form-row .error-text").removeClass("hidden");
                }
            }
        }
        changeNeedGuestRooms();
    }

    function calculateDates(start, end) {
        console.log(start);
        console.log(end);
        var date1 = new Date(start);
        console.log(date1);
        var d1 = Date.parse(start);
        var d2 = Date.parse(end);
        console.log(d1);
        console.log(d2);
        var modifier = (1000 * 60 * 60 * 24);
        var days = Math.round( d2 / modifier ) - Math.round( d1 / modifier ) + 1;
        var weekday = new Array(7);
        weekday[0]=  "Sunday";
        weekday[1] = "Monday";
        weekday[2] = "Tuesday";
        weekday[3] = "Wednesday";
        weekday[4] = "Thursday";
        weekday[5] = "Friday";
        weekday[6] = "Saturday";

        // remove current content
        wizard.find(".room-number-table .input-table").html('');
        console.log("adding dates");
        console.log(days);
        // add the input boxes for each date
        for(var i = 0; i < days;i++) {
            var currDate = new Date(d1 + (i * 24 * 60 * 60 * 1000));
            console.log("add date");
            wizard.find(".room-number-table .input-table").append(
                '<div class="date-cell">' +
                '<span class="day">' + weekday[currDate.getUTCDay()] + '</span>' +
                '<span class="date">' + (currDate.getUTCMonth() + 1) + '/' + currDate.getUTCDate() + '</span>' +
                '<input type="number" class="room" min="0" value="0" id="rooms_' + (currDate.getUTCMonth() + 1) + '_' + currDate.getUTCDate() + '" disabled required/>' +
                '<input type="number" class="suite" min="0" value="0" id="suites' + (currDate.getUTCMonth() + 1) + '_' + currDate.getUTCDate() + '" disabled required/>' +
                '</div>'
            );
        }

        if($("[name='need-guest-rooms']:checked").val() === "Yes") {
            $(".date-cell input").attr("disabled",false);
        }
    }

    function deleteHotel() {
        //remove the hotel item
        $(this).closest(".hotel").remove();
    }

    function submitRFP() {
        // assemble property ID list
        var propList = assemblePropertyList();
        var rfpJSON = [];
        var promoInfo = 'No';
        var salesContact = 'No';
        var count;

        if($("#rfp-promo-info:checked").val() !== undefined) {
            promoInfo = "Yes";
        }
        if($("#rfp-sales-contact:checked").val() !== undefined) {
            salesContact = "Yes";
        }

        if(eventType === 'Meeting') {
            rfpJSON = [
                {"name": "secret", "value": "5DC712DC-CD93-4B7A-BEEB-1DAC89E62D3A"},
                {"name": "releaseversion","value": "?REL1.0"},
                {"name": "rfpSelectedLocationIds","value": propList},

                {"name": "rfpMeetingNameInput", "value": $("#meeting-meeting-name").val()},
                {"name": "rfpContactFirstNameInput","value": $("#rfp-first-name").val()},
                {"name": "rfpContactLastNameInput","value": $("#rfp-last-name").val()},
                {"name": "rfpCompanyNameInput","value": $("#meeting-company-name").val()},
                {"name": "rfpContactAddress1Input","value": $("#rfp-address-1").val()},
                {"name": "rfpContactAddress2Input","value": $("#rfp-address-2").val()},
                {"name": "rfpContactCityRegionInput","value": $("#rfp-city").val()},
                {"name": "rfpContactStateProvinceInput","value": $("#rfp-state").val()},
                {"name": "rfpContactPostalCodeInput","value": $("#rfp-postal-code").val()},
                {"name": "rfpContactCountrySelect","value": $("#rfp-country").val()},
                {"name": "rfpContactPhoneNumberInput","value": $("#rfp-phone").val()},
                {"name": "rfpContactEmailInput","value": $("#rfp-email").val()},
                {"name": "rfpAttendeeQuantityInput","value": $("#rfp-attendees").val()},
                {"name": "rfpStartDateDate", "value": $("#rfp-start-date").val()},
                {"name": "rfpDepartDateDate", "value": $("#rfp-end-date").val()},
                {"name": "rfpudfOvernightGuestRooms", "value": $('[name="need-guest-rooms"]:checked').val()},
                {"name": "rfpGeneralCommentsTA", "value": $("#rfp-comments").val()},
                {"name": "rfpudfSendPromotionalInfo", "value": promoInfo},
                {"name": "rfpudfSalesContactMe", "value": salesContact},
                {"name": "rfpExternalMarketSegmentInput", "value": "Other"},
                {"name": "rfpExternalLeadSourceInput", "value": "Omnihotels.com"}
            ];

            count = 1;
            $(".date-cell").each(function() {
                if ($(this).find(".room").val()) {
                    rfpJSON.push({"name": "rfpRBRun_Of_House" + (("0" + count).slice(-2)),"value": $(this).find(".room").val()});
                }
                if ($(this).find(".suite").val()) {
                    rfpJSON.push({"name": "rfpRBSuite__Single" + (("0" + count).slice(-2)),"value": $(this).find(".suite").val()});
                }
                count++;
            });
        }
        else {
            if(eventType === 'Wedding') {
                rfpJSON = [
                    {"name": "secret", "value": "5DC712DC-CD93-4B7A-BEEB-1DAC89E62D3A"},
                    {"name": "releaseversion","value": "?REL1.0"},
                    {"name": "rfpSelectedLocationIds","value": propList},

                    {"name": "rfpMeetingNameInput", "value": $("#rfp-last-name").val() + " Wedding"},
                    {"name": "rfpContactFirstNameInput","value": $("#rfp-first-name").val()},
                    {"name": "rfpContactLastNameInput","value": $("#rfp-last-name").val()},
                    {"name": "rfpudfRelationship", "value": $("#wedding-relationship").val()},
                    {"name": "rfpCompanyNameInput","value": $("#rfp-last-name").val() + " Wedding"},
                    {"name": "rfpContactAddress1Input","value": $("#rfp-address-1").val()},
                    {"name": "rfpContactAddress2Input","value": $("#rfp-address-2").val()},
                    {"name": "rfpContactCityRegionInput","value": $("#rfp-city").val()},
                    {"name": "rfpContactStateProvinceInput","value": $("#rfp-state").val()},
                    {"name": "rfpContactPostalCodeInput","value": $("#rfp-postal-code").val()},
                    {"name": "rfpContactCountrySelect","value": $("#rfp-country").val()},
                    {"name": "rfpContactPhoneNumberInput","value": $("#rfp-phone").val()},
                    {"name": "rfpContactEmailInput","value": $("#rfp-email").val()},
                    {"name": "rfpudfContactBy","value": $('[name="com-method"]:checked').val()},
                    {"name": "rfpAttendeeQuantityInput","value": $("#rfp-attendees").val()},
                    {"name": "rfpGeneralCommentsTA", "value": $("#rfp-comments").val()},
                    {"name": "rfpudfSendPromotionalInfo", "value": promoInfo},
                    {"name": "rfpudfNumberOfGuests","value": $("#wedding-guestrooms").val()},
                    {"name": "rfpStartDateDate", "value": $("#wedding-date").val()},
                    {"name": "rfpudfCeremonyOnSite", "value": $('[name="ceremony-on-site"]:checked').val()},
                    {"name": "rfpudfPlannedWeddingTime", "value": $("#wedding-time").val()},
                    {"name": "rfpExternalMeetingTypeSelect", "value": "Wedding"},
                    {"name": "rfpExternalMarketSegmentInput", "value": "Other"},
                    {"name": "rfpExternalLeadSourceInput", "value": "Omnihotels.com"},
                    {"name": "rfpExternalMeetingTypeInput", "value": "Wedding"},
                    {"name": "rfpRespondByDateDate", "value": respondBy}
                ];

                $(".wedding-selected-options:checked").each(function() {
                   rfpJSON.push({"name": "rfpudfSelectedOptions","value": $(this).val()});
                });
                $(".wedding-assistance:checked").each(function() {
                    rfpJSON.push({"name": "rfpudfWouldLikeAssistance","value": $(this).val()});
                });
            }
            else {
                if(eventType === 'Social') {
                    rfpJSON = [
                        {"name": "secret", "value": "5DC712DC-CD93-4B7A-BEEB-1DAC89E62D3A"},
                        {"name": "releaseversion","value": "?REL1.0"},
                        {"name": "rfpSelectedLocationIds","value": propList},

                        {"name": "rfpMeetingNameInput", "value": $("#social-meeting-name").val()},
                        {"name": "rfpContactFirstNameInput","value": $("#rfp-first-name").val()},
                        {"name": "rfpContactLastNameInput","value": $("#rfp-last-name").val()},
                        {"name": "rfpCompanyNameInput","value": $("#social-company-name").val()},
                        {"name": "rfpContactAddress1Input","value": $("#rfp-address-1").val()},
                        {"name": "rfpContactAddress2Input","value": $("#rfp-address-2").val()},
                        {"name": "rfpContactCityRegionInput","value": $("#rfp-city").val()},
                        {"name": "rfpContactStateProvinceInput","value": $("#rfp-state").val()},
                        {"name": "rfpContactPostalCodeInput","value": $("#rfp-postal-code").val()},
                        {"name": "rfpContactCountrySelect","value": $("#rfp-country").val()},
                        {"name": "rfpContactPhoneNumberInput","value": $("#rfp-phone").val()},
                        {"name": "rfpContactEmailInput","value": $("#rfp-email").val()},
                        {"name": "rfpAttendeeQuantityInput","value": $("#rfp-attendees").val()},
                        {"name": "rfpStartDateDate", "value": $("#rfp-start-date").val()},
                        {"name": "rfpDepartDateDate", "value": $("#rfp-end-date").val()},
                        {"name": "rfpudfOvernightGuestRooms", "value": $('[name="need-guest-rooms"]:checked').val()},
                        {"name": "rfpGeneralCommentsTA", "value": $("#rfp-comments").val()},
                        {"name": "rfpudfContactBy","value": $('[name="com-method"]:checked').val()},
                        {"name": "rfpudfSendPromotionalInfo", "value": promoInfo},
                        {"name": "rfpudfSalesContactMe", "value": salesContact},
                        {"name": "rfpudfPurposeOfEvent", "value": $("#social-purpose").val()},
                        {"name": "rfpExternalMarketSegmentInput", "value": "SMERF"},
                        {"name": "rfpExternalLeadSourceInput", "value": "Website"},
                        {"name": "rfpExternalMeetingTypeInput", "value": "Group"}
                    ];

                    count = 1;
                    $(".date-cell").each(function() {
                        if ($(this).find(".room").val()) {
                            rfpJSON.push({"name": "rfpRBRun_Of_House" + (("0" + count).slice(-2)),"value": $(this).find(".room").val()});
                        }
                        if ($(this).find(".suite").val()) {
                            rfpJSON.push({"name": "rfpRBSuite__Single" + (("0" + count).slice(-2)),"value": $(this).find(".suite").val()});
                        }
                        count++;
                    });
                }
            }
        }

        //submit JSON
        //console.log(rfpJSON);

        var shouldSubmit = true;
        $(".rfp-wizard input").each(function() {
            if(!$(this)[0].checkValidity()) {
                shouldSubmit = false;
                $(this).addClass("input-error");
                //console.log($(this));
                $(this).siblings(".error-text").removeClass("hidden");
            }
            else {
                $(this).removeClass("input-error");
                $(this).siblings(".error-text").addClass("hidden");
            }
        });
        $(".rfp-wizard select").each(function() {
            if(!$(this)[0].checkValidity()) {
                shouldSubmit = false;
                $(this).addClass("input-error");
                $(this).siblings(".error-text").removeClass("hidden");
                //console.log($(this));
            }
            else {
                $(this).removeClass("input-error");
                $(this).siblings(".error-text").addClass("hidden");
            }
        });

        if(shouldSubmit) {
            $(".submit-rfp-button").attr("disabled",true);
            $(".submit-rfp-button").html("Submitting RFP...");
            $(this).closest(".section-contents").find(".error-text").addClass('hidden');
            //if (typeof cta === 'function') {
            //    cta('Internal Conversion Link', 'rfp-wizard', 'Submit RFP', 'RFP Form Bottom');
            //}

            if (typeof formSuccess === 'function') {
                $('div.rfp-hotels-list > div.hotel').each(function (index) {
                    var hotelCode = $(this).attr('data-hotel-code');
                    formSuccess(hotelCode);
                });
            }

            $.ajax({
                url: rfpURL,
                type: 'POST',
                data: JSON.stringify(rfpJSON),
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
                async: false,
                success: function(msg) {
                    AddToRFP.clearRFPCookie();
                    window.location.href = window.location.href + "/rfp-thanks";

                },
                error: function() {
                    $(".submit-rfp-button").attr("disabled",false);
                    $(".submit-rfp-button").html("Submit RFP");
                    $(this).closest(".section-contents").append('<span class="error-text">An error occurred. Please try again.</span>');
                    if (typeof formFail === 'function') {
                        formFail();
                    }
                }
            });
        }
        else {
            var firstError = $('.input-error').eq(0).attr('id');
            $('body').scrollTop($('#' + firstError).offset().top - 120);
            $(this).closest(".section-contents .button-conatiner").find(".error-text").removeClass('hidden');
            if (typeof formFail === 'function') {
                formFail();
            }
        }
    }

    function inputChange() {
        if(!$(this)[0].checkValidity()) {
            $(this).addClass("input-error");
            //console.log($(this));
            $(this).siblings(".error-text").removeClass("hidden");
        }
        else {
            $(this).removeClass("input-error");
        }

        if($("[name='need-guest-rooms']:checked").val() === "Yes") {
            $(".date-cell input").attr("disabled",false);
        }
        else {
            $(".date-cell input").attr("disabled",true);
        }
    }

    function assemblePropertyList() {
        var list = "";

        // add each remaining hotel to the list
        wizard.find(".hotel").each(function() {
            list += $(this).attr("data-property-id") + ";";
        });

        if(list.length > 0) {
            // remove trailing comma
            return list.substring(0, list.length - 1);
        }
        else {
            return list;
        }
    }


    $(onDocReady);

    return {};

})(window, $j);
